const defaultState = [];
export default (state = defaultState, action) => {
  switch (action.type) {
    case 'ALL_NUMBERS_SUCCESS':
    case 'USER_NUMBERS_SUCCESS':
    case 'GET_FILTER_BY_NUMBER_SUCCESS':
      return action.numbers.allNumbers;
    default:
      return state;
  }
};
